import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { card } from "checkout-experience/layouts/checkout-experience.css";

const OrderSummarySection = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="order-summary-section"
      className={card}
      aria-labelledby="orderSummarySectionHeaderId"
    >
      <span id="orderSummarySectionHeaderId" hidden>
        {t("orderSummary.title")}
      </span>
      {children}
    </section>
  );
};

export default OrderSummarySection;
